<template>
  <el-dialog
    v-if="visible"
    visible
    show-close
    :title="$l('dialog_title_custLogo') || '客户LOGO编辑'"
    width="800px"
    top="10vh"
    :close-on-click-modal="false"
    :before-close="() => close()"
    append-to-body
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :bigImageCode="bigImageCode"
      :bigImageUrl="bigImageUrl"
      :middleImageCode="middleImageCode"
      :middleImageUrl="middleImageUrl"
      :smallImageCode="smallImageCode"
      :smallImageUrl="smallImageUrl"
      @close="close"
      @change="(e) => $emit('change', e)"
    />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_close') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="$refs.main.save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    bigImageCode: { type: String, default: '' },
    bigImageUrl: { type: String, default: '' },
    middleImageCode: { type: String, default: '' },
    middleImageUrl: { type: String, default: '' },
    smallImageCode: { type: String, default: '' },
    smallImageUrl: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
